import { exportToCSV, exportToPDF } from '../../../../utils/exportUtils';
import React, { useState, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { saveAs } from 'file-saver';
import apiClient from "../../../../services/api-client";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { useMountEffect } from 'primereact/hooks';
import StorageHelper from '../../../../utils/storage-helper';
import AppCard from "../../../../components/ui/AppCard";

const EmployeesProfileReportTable = () => {
  const [employees, setemployees] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');

  const dt = useRef(null);

  const cols = [
    { field: 'firstName', header: 'First name' },
    { field: 'lastName', header: 'Last name' },
    { field: 'emailAddress', header: 'Email' },
    { field: 'phoneNumber', header: 'Phone number' },
    { field: 'locked', header: 'isLocked' }, 
    { field: 'isActive', header: 'isActive' },
    { field: 'creationTimestamp', header: 'Created at' },
    { field: 'lastUpdateTimestamp', header: 'Updated at' }
  ];

  const exportColumns = cols.map((col) => ({ title: col.header, dataKey: col.field }));

  useMountEffect(() => {
    fetchUsers();
  }, []);

  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({ selectionOnly });
  };

  const exportPdf = () => {
    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then(() => {
        const doc = new jsPDF.default();
        doc.autoTable(exportColumns, employees);
        doc.save('doves-self-service-employees-profiles-report.pdf');
      });
    });
  };

  const fetchUsers = async () => {
    try {
      await apiClient.get('users/employees', {
        headers: {
          Authorization: 'Bearer ' + (StorageHelper.get('token'))
        }
      }).then((response) => {
        if (response.data.status === "SUCCESS") { 
          setemployees((response.data.responseBody));
        }
      });
    } catch (error) {}
  };

  const globalFilterElement = (
    <div className="relative w-full max-w-xs">
        <i className="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-base-content/50"></i>
        <input
            type="text"
            className="input input-bordered w-full pl-10 h-10 shadow-sm bg-base-100 rounded-full"
            placeholder="Search..."
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
        />
    </div>
  );

  const header = (
      <div className="flex flex-col sm:flex-row gap-4 justify-between items-center w-full">
          {globalFilterElement}
          <div className="flex items-center gap-3 ml-auto">
              <div className="dropdown dropdown-end">
                  <div tabIndex={0} role="button" className="btn btn-outline btn-ghost h-10 min-h-0 shadow-sm rounded-full">
                      <i className="pi pi-file-export"></i> Export
                  </div>
                  <ul tabIndex={0} className="dropdown-content z-[99] menu p-2 shadow-sm bg-base-100 border border-base-200 rounded-box w-52 mt-2">
                                    <li><a onClick={() => exportToCSV(dt, 'Employees')}><i className="pi pi-file-excel text-success"></i> Download CSV</a></li>
                                    <li><a onClick={() => exportToPDF(dt, 'Employees', 'Employees Report')}><i className="pi pi-file-pdf text-error"></i> Download PDF</a></li>
                                </ul>
              </div>
          </div>
      </div>
  );


    const activeBodyTemplate = (rowData) => {
      const active = rowData.isActive;
      return <span className={`badge border-0 font-semibold text-xs ${active ? 'bg-success/10 text-success' : 'bg-error/10 text-error'}`}>{active ? 'Active' : 'Inactive'}</span>;
  };

  const lockedBodyTemplate = (rowData) => {
      const locked = rowData.locked || rowData.isLocked;
      return <span className={`badge border-0 font-semibold text-xs ${locked ? 'bg-error/10 text-error' : 'bg-success/10 text-success'}`}>{locked ? 'Locked' : 'Unlocked'}</span>;
  };


    const humanReadableDateBodyTemplate = (rowData, field) => {
        const dateVal = rowData[field];
        if (!dateVal) return '-';
        try {
            return new Date(dateVal).toLocaleString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        } catch (e) {
            return dateVal;
        }
    };

    return (


    <div className="w-full">
      <AppCard title="Employees Profile Report">
        <DataTable
            paginator 
            rows={5} 
            rowsPerPageOptions={[5, 10, 25, 50]}
            ref={dt}
            value={employees}
            header={header}
            globalFilter={globalFilter}
            emptyMessage="No employees found"
            paginatorTemplate="CurrentPageReport RowsPerPageDropdown PrevPageLink PageLinks NextPageLink"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        >
          {cols.map((col, index) => (
              <Column key={index} field={col.field} header={col.header} body={col.field === 'isActive' ? activeBodyTemplate : (col.field === 'locked' || col.field === 'isLocked') ? lockedBodyTemplate : (col.field === 'creationTimestamp' || col.field === 'lastUpdateTimestamp') ? (rowData) => humanReadableDateBodyTemplate(rowData, col.field) : null} />
          ))}
        </DataTable>
      </AppCard>
    </div>
  );
};

export default EmployeesProfileReportTable;
